export const useBase64 = () => {
  const convertFilterToBase64 = (data: any) => {
    return btoa(JSON.stringify(data));
  };
  return { convertFilterToBase64 };
};
